import { createSlice } from "@reduxjs/toolkit";

const normalizeTableReference = (value) => String(value ?? "")
  .trim()
  .toLowerCase()
  .replace(/^table\s*/, "")
  .replace(/^t-/, "");

const notificationSlice = createSlice({
  name: "notifications",
  initialState: {
    list: [],
    ordersRevision: 0,
    tablesRevision: 0,
    requestsRevision: 0,
    takeawayRevision: 0
  },
  reducers: {
    addNotification: (state, action) => {

      const exists = state.list.some(
        n => action.payload.notificationId != null && n.notificationId === action.payload.notificationId
      );

      if (!exists) {
        const type = action.payload.type;
        if (['NEW_ORDER', 'KOT_UPDATED', 'KDS_REFRESH', 'TABLE_STATUS_CHANGED', 'PAYMENT_DONE'].includes(type)) state.ordersRevision++;
        if (['NEW_ORDER', 'TABLE_STATUS_CHANGED', 'PAYMENT_DONE'].includes(type)) state.tablesRevision++;
        if (['WAITER_REQUEST', 'SERVICE_REQUEST_UPDATED'].includes(type)) state.requestsRevision++;
        if (['TAKEAWAY_NEW_ORDER', 'TAKEAWAY_ORDER_UPDATED', 'TAKEAWAY_PAYMENT_DONE', 'KDS_REFRESH'].includes(type)) state.takeawayRevision++;
        if (['KOT_UPDATED', 'KDS_REFRESH', 'TABLE_STATUS_CHANGED', 'SERVICE_REQUEST_UPDATED', 'TAKEAWAY_ORDER_UPDATED'].includes(type)) return;
        state.list.unshift(action.payload);
      }

    },
    syncRealtime: state => {
      state.ordersRevision++;
      state.tablesRevision++;
      state.requestsRevision++;
      state.takeawayRevision++;
    },
    clearAllNotifications: (state) => {
      state.list = [];
    },
    acknowledgeTableOrders: (state, action) => {
      const tableNumber = normalizeTableReference(action.payload?.tableNumber);
      const tableOtp = String(action.payload?.tableOtp ?? "").trim();

      state.list.forEach(notification => {
        if (notification.type !== "NEW_ORDER") return;

        const matchesNumber = tableNumber && normalizeTableReference(notification.tableNumber) === tableNumber;
        const matchesOtp = tableOtp && String(notification.tableOtp ?? "").trim() === tableOtp;
        if (matchesNumber || matchesOtp) notification.acknowledged = true;
      });
    }
  }
});

export const { addNotification, clearAllNotifications, syncRealtime, acknowledgeTableOrders } = notificationSlice.actions;
export default notificationSlice.reducer;
